declare global {
    interface Number {
        padStart(length: number, fill?: string, base?: number): string;

        padEnd(length: number, fill?: string, base?: number): string;
    }

    interface Array<T> {
        remove(element: T): boolean;

        max(compare: (a: T, b: T) => number): T;

        first(): T;

        last(index?: number): T;

        unique<K>(discriminator?: (element: T) => K): Array<T>;

        take(count?: number): T[];

        skip(count?: number): this;
    }

    interface Math {
        clamp(value: number, min: number, max: number): number;
    }

    interface String {
        capitalize(): string;

        format(...args: any[]): string;

        formatObject(args: { [key: string]: any }): string;

        contains(substring: string): boolean;
    }
}

/*** NUMBER PADDING ***/
Number.prototype.padStart = function (length, fill = " ", base) {
    const str = this.toString(base);
    const repeat = str.length <= length ? length - str.length : 0;
    return fill.repeat(repeat) + str;
};

Number.prototype.padEnd = function (length, fill = " ", base) {
    const str = this.toString(base);
    const repeat = str.length <= length ? length - str.length : 0;
    return str + fill.repeat(repeat);
};

/*** ARRAY EXTENSIONS ***/
Array.prototype.remove = function (element) {
    const index = this.indexOf(element);
    if (index < 0) return false;
    this.splice(index, 1);
    return true;
};

Array.prototype.max = function (compare = (a, b) => a - b) {
    let max = this[0];
    for (let index = 1; index < this.length; index++) {
        const element = this[index];
        if (compare(max, element) < 0) max = element;
    }
    return max;
};

Array.prototype.first = function () {
    if (this.length > 0) return this[0];
    return undefined;
};

Array.prototype.last = function (index = 0) {
    if (this.length > 0) return this[this.length - 1 - index];
    return undefined;
};

Array.prototype.unique = function (fn = (v) => v) {
    const set = new Set();
    return this.filter((v) => {
        const key = fn(v);
        if (set.has(key)) return false;
        set.add(key);
        return true;
    });
};

Array.prototype.take = function (count= 1) {
    if (count > 0) {
        return this.splice(0, count);
    } else if (count < 0) {
        return this.splice(count, this.length);
    }

    throw new Error(`Cannot take '${count}' elements from array.`);
}

Array.prototype.skip = function (count = 1) {
    if (count > 0) {
        this.splice(0, count);
    } else if (count < 0) {
        this.splice(count, this.length);
    }
    return this;
}

Math.clamp = (value, min, max) => Math.min(Math.max(value, min), max);

String.prototype.capitalize = function () {
    return this[0].toUpperCase() + this.slice(1);
};

String.prototype.format = function () {
    const args = arguments;
    return this.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != "undefined" ? args[number] : match;
    });
};

String.prototype.formatObject = function (args) {
    return this.replace(/{(\w+)}/g, function (match, key) {
        return typeof args[key] != "undefined" ? args[key] : match;
    });
};

String.prototype.contains = function (substring) {
    return this.indexOf(substring) >= 0;
};

export {};
